/* storybook-check-ignore */
import { FunctionComponent } from 'react';

const SimpleInfoIcon: FunctionComponent<{ size?: string }> = ({ size = '1rem' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 12 12`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2.21951C3.91209 2.21951 2.21951 3.91209 2.21951 6C2.21951 8.08791 3.91209 9.78049 6 9.78049C8.08791 9.78049 9.78049 8.08791 9.78049 6C9.78049 3.91209 8.08791 2.21951 6 2.21951ZM1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6ZM5.26829 6C5.26829 5.73059 5.48669 5.5122 5.7561 5.5122H6.2439C6.51331 5.5122 6.73171 5.73059 6.73171 6V7.95122C6.73171 8.22063 6.51331 8.43902 6.2439 8.43902H5.7561C5.48669 8.43902 5.26829 8.22063 5.26829 7.95122V6ZM6 5.02439C5.59589 5.02439 5.26829 4.69679 5.26829 4.29268C5.26829 3.88857 5.59589 3.56098 6 3.56098C6.40411 3.56098 6.73171 3.88857 6.73171 4.29268C6.73171 4.69679 6.40411 5.02439 6 5.02439Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SimpleInfoIcon;
